import styled from 'styled-components';
import { transparentize } from 'polished';

export const FileUploadContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${(props) => props.theme.space.lg};
    border: dashed
        ${(props) =>
            props.theme.line +
            ' ' +
            transparentize(0.9, props.theme.wab.black00)};
    border-radius: ${(props) => props.theme.radius.sm};
    background-color: ${(props) =>
        props.isDragActive ? props.theme.wab.grey10 : props.theme.wab.white10};
    transition: all ${(props) => props.theme.transition.xs};
    margin-bottom: ${(props) => props.theme.space.xs};

    &:hover,
    &:active,
    &:focus {
        background-color: ${(props) => props.theme.wab.grey10};
    }

    @media ${(props) => props.theme.screen.max.sm} {
        padding: ${(props) => props.theme.space.sm};
    }
`;

export const FileUploadInput = styled.input`
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    border: none;

    &:focus {
        outline: none;
    }
`;
